import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div<{ $active: boolean }>`
  display: flex;
  padding: 0 1rem 0 1rem;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  min-height: 8rem;
  width: 90%;
  background-color: ${({ $active }) =>
    $active ? COLORS.background : COLORS.backgroundDark};
  margin: 1rem 0 0.5rem 0;
  border-radius: 5px;
  border: none;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background-color 0.2s ease;

  @media (max-width: 1200px) {
    padding: 0.5rem;
    min-height: 6rem;
    width: 95%;
  }
`

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  &:nth-child(1) {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;

    p {
      font-size: 1rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      position: relative;
      padding-left: 1.2rem;

      &::before {
        content: '•';
        position: absolute;
        left: 0;
        font-size: 1rem;
        line-height: 1.2rem;
      }

      &:hover {
        white-space: normal;
        overflow: visible;
        max-width: 100%;
      }
    }
    p:nth-of-type(1) {
      margin-bottom: 0.7rem;
    }
    p:nth-of-type(2):nth-last-of-type(2) {
      margin-bottom: 0.7rem;
    }
    span {
      font-weight: bold;
    }

    @media (max-width: 1200px) {
      width: 35%;

      p {
        font-size: 0.85rem;
        padding-left: 0.8rem;

        &::before {
          font-size: 0.85rem;
        }
      }
    }
  }

  &:nth-child(2) {
    width: 15%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > p {
      font-size: 1rem;
      display: flex;
      align-items: center;
      width: 100%;
    }

    > p::before {
      content: attr(data-label);
      margin-right: 8px;
      font-weight: bold;
    }

    @media (max-width: 1200px) {
      width: 20%;
      > p {
        font-size: 0.85rem;
      }
    }
  }

  &:nth-child(3) {
    width: 15%;
    flex-direction: row;
    > label {
      font-weight: bold;
    }
    .fui-Input {
      width: 4rem;
    }

    @media (max-width: 1200px) {
      width: 20%;

      > label {
        font-size: 0.85rem;
      }

      .fui-Input {
        width: 3rem;
      }
    }
  }

  &:nth-child(4) {
    width: 15%;
    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      > p {
        font-size: 1rem;
        display: flex;
        align-items: center;
        width: 100%;
      }

      > p::before {
        content: attr(data-label);
        margin-right: 8px;
        font-weight: bold;
      }
    }

    @media (max-width: 1200px) {
      width: 15%;
      > div > p {
        font-size: 0.85rem;
      }
    }
  }

  &:nth-child(5) {
    width: 15%;

    .remove-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .remove-button {
        color: ${COLORS.white};
        background-color: ${COLORS.primary};

        &:hover {
          background-color: ${COLORS.secondary};
        }
      }

      .delete-icon {
        display: none;
        cursor: pointer;
        color: ${COLORS.white};
        background-color: #202a44;
        border-radius: 4px;
        padding: 4px;

        &:hover {
          background-color: #cb333b;
        }
      }
    }

    @media (max-width: 1200px) {
      width: 10%;

      .remove-container {
        .remove-button {
          display: none;
        }

        .delete-icon {
          display: block;
        }
      }
    }
  }

  @media (max-width: 480px) {
    &:nth-child(1) {
      width: 30%;
      p {
        font-size: 0.75rem;
      }
    }

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      p,
      label {
        font-size: 0.75rem;
      }
    }
  }
`
